import { useQuery } from "@tanstack/react-query";
import { GET_NEXT_STEPS } from "../api/queries";
import { graphQLClient } from "../graphqlClient";
import { useReactQueryErrorReporter } from "./use-error-reporter";
import { useCurrentUser } from "./useCurrentUser";
import { useReporting } from "./useReporting";
import { useProductFeatures } from "./useProductFeatures";

export const useNextSteps = () => {
  const currentUser = useCurrentUser();
  const userPath = currentUser?.userPath;
  const { recentEvents } = useReporting();
  const { productPlans } = useProductFeatures();

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["nextSteps", recentEvents?.length || 0, productPlans],
    queryFn: () => {
      return graphQLClient.request(GET_NEXT_STEPS, {
        userPath,
        recentEvents,
        productPlans: productPlans || [],
      });
    },
    enabled: !!userPath,
  });

  useReactQueryErrorReporter("Could not load next steps data", error, false);

  return {
    nextSteps: data?.getNextSteps || [],
    loading: isLoading,
    error,
    refetch,
  };
};
